/*eslint-disable*/
// chakra imports
import { Box,  Button, Flex, Link, Stack, Text, useColorModeValue } from "@chakra-ui/react";
import IconBox from "../../components/Icons/IconBox";
import { CreativeTimLogo } from "../../components/Icons/Icons";

import { Separator } from "../../components/Separator";
import React from "react";
import { NavLink } from "react-router-dom";
import {routes} from "../../Routes"

const SidebarContent = ({ logoText }) => {

  const inactiveBg = useColorModeValue("white", "gray.700");
  const inactiveColor = useColorModeValue("gray.400", "gray.400");

  const myroutes=routes

  const createLinks = (routes) => {
    // Chakra Color Mode
    return routes.map((prop, key) => {
      return (
        <NavLink to={prop.layout + prop.path} key={prop.name}>
            <Button
              boxSize="initial"
              justifyContent="flex-start"
              alignItems="center"
              bg="transparent"
              mb={{ xl: "12px", }}
              mx={{ xl: "auto", }}
              py="12px"
              ps={{ sm: "10px", xl: "16px", }}
              borderRadius="15px"
              _hover={{}}
              w="100%"
              _active={{ bg: "inherit", transform: "none", borderColor: "transparent", }}
              _focus={{ boxShadow: "none",  }}
            >
              <Flex>
                <IconBox bg={inactiveBg} color="teal.300" h="30px" w="30px" me="12px" >
                  {prop.icon}
                </IconBox>
                <Text color={inactiveColor} my="auto" fontSize="sm">
                  { prop.name}
                </Text>
              </Flex>
            </Button>
        </NavLink>
      );
    });
  };

  return (
    <>
      <Box pt={"25px"} mb="12px">
        <Link
          href={`${process.env.PUBLIC_URL}/#/`}
          target="_blank"
          display="flex"
          lineHeight="100%"
          mb="30px"
          fontWeight="bold"
          justifyContent="center"
          alignItems="center"
          fontSize="11px"
        >
          <CreativeTimLogo w="32px" h="32px" me="10px" />
          <Text fontSize="sm" mt="3px">
            {logoText}
          </Text>
        </Link>
        <Separator></Separator>
      </Box>
      <Stack direction="column" mb="40px">
        <Box>
          <>{createLinks(myroutes)}</>
        </Box>
      </Stack>
    </>
  )
}

export default SidebarContent
